import { useTheme, Box, Tabs, Tab } from '@mui/material';
import { colorTheme } from 'theme';
import { useEffect, useState } from 'react';
import CurrentHoldings from './currentHoldings';
import HoldingHistory from './holdingHistory';
import { type TabPanelProps } from '@mui/lab';
import { getMasterFundsList } from 'service/OrderService';
import { useAppDispatch } from 'store';
import { setAllMasterFunds } from 'store/fund';

function TabPanel(props: TabPanelProps): JSX.Element {
  const { children, value, index, ...other } = props;

  const dispatch = useAppDispatch();

  const getAllMasterFunds = async (): Promise<void> => {
    try {
      const result = await getMasterFundsList();
      dispatch(setAllMasterFunds(result?.data));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    void getAllMasterFunds();
  }, []);

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      id={`vertical-tabpanel-${index}`}
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3, height: '75vh' }}>{children}</Box>}
    </div>
  );
}

const Holdings = (): JSX.Element => {
  const [value, setValue] = useState(0);
  const handleChange = (
    event: React.SyntheticEvent,
    newValue: number,
  ): void => {
    setValue(newValue);
  };
  const theme = useTheme();
  const colors = colorTheme(theme.palette.mode);

  return (
    <Box>
      <Box
        sx={{
          maxWidth: {
            xs: 320,
            sm: 480,
            md: '100%',
          },
          borderRadius: 3,
          px: 2,
          boxShadow: 2,
          bgcolor: 'background.paper',
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          indicatorColor="secondary"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          TabIndicatorProps={{
            style: {
              backgroundColor: colors.greenAccent[600],
            },
          }}
          sx={{
            '& .MuiTab-root.Mui-selected': {
              color: colors.greenAccent[500],
            },
          }}
        >
          <Tab label="Current Holdings" />
          <Tab label="Holdings History" />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <CurrentHoldings />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <HoldingHistory />
      </TabPanel>
    </Box>
  );
};

export default Holdings;
